  <template >
   <div class="formPosition">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col>

              <h4 style="text-align:center;"> <span> Filtragem dos Dados</span></h4>

<div class="text-center">

 <v-container fluid>
    <v-row align="center">
       <v-col class="d-flex" cols="12" sm="6">
        <v-select
          v-model="select1"
          :items="pendentes"
           item-value="idInstituicaoPendente"
          item-text="descricao"
          @change="SelecionaUser()"
          label="Selecione a entidade"
        ></v-select>
      </v-col>

    <v-btn @click="AceitarInstituicao()" class="ma-2" tile color="indigo" dark>Aceitar</v-btn>
    <v-btn @click="Carregar()" class="ma-2" tile outlined color="success">
      <v-icon left>mdi-pencil</v-icon> Rejeitar
    </v-btn>

        <v-col class="d-flex" cols="4" sm="2">

        <v-progress-circular
        v-if="progresso"
        indeterminate
        color="green"
    ></v-progress-circular>
      </v-col>
      <v-col class="d-flex" cols="3" sm="3">
         <label style="color:red" v-if="( select1 !== null && select_anolectivo !== null && !Pessoas.length && progresso === false)">Não existe dado neste ano</label>
      </v-col >
    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>

      </v-list-item-content>
    </v-list-item>

<v-row>
  <v-col md="6">
    <v-card-text>
      <strong> Dados da Instituição</strong>
    </v-card-text>
    <hr>
    <v-row>
     <v-col md="8">
          <v-chip color="pink" style="margin:4px;color:white">Nome da Instituição: <strong>{{(this.instituicao_dados.length!=0)?(this.instituicao_dados[0].descricao):''}}</strong></v-chip>
     </v-col>
     <v-col md="4">
          <v-chip color="pink" style="margin:4px;color:white">Sigla: <strong>{{(this.instituicao_dados.length!=0)?(this.instituicao_dados[0].sigla):''}}</strong></v-chip>
     </v-col>
    </v-row>
    <v-card-text>
      <strong> Dados dos membros Directivos</strong>
    </v-card-text>
    <v-row>
     <v-col md="8">
          <v-chip style="margin:4px">Director Geral:<strong>{{(this.instituicao_dados.length!=0)?(this.instituicao_dados[0].nomeDg):''}}</strong></v-chip>
     </v-col>
     </v-row>
       <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Email :<strong>{{(this.instituicao_dados.length!=0)?(this.instituicao_dados[0].emailDg):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">Telefone :<strong>{{(this.instituicao_dados.length!=0)?(this.instituicao_dados[0].telefoneDg):''}}</strong></v-chip>
     </v-col>
    </v-row>
     <v-row>
     <v-col md="8">
          <v-chip style="margin:4px">Director Pedagogico :<strong>{{(this.instituicao_dados.length!=0)?(this.instituicao_dados[0].nomeDp):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Email :<strong>{{(this.instituicao_dados.length!=0)?(this.instituicao_dados[0].emailDp):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">Telefone :<strong>{{(this.instituicao_dados.length!=0)?(this.instituicao_dados[0].telefoneDp):''}}</strong></v-chip>
     </v-col>
    </v-row>

    <hr>
  </v-col>
  <v-col md="6">
    <v-card-text>
      <strong> {{titulo}}</strong>
    </v-card-text>
    <hr>

    <v-data-table
            :headers="headers"
            :items="instituicao_dados"
          >

      </v-data-table>

  </v-col>
</v-row>
  </v-card>

  </v-container>

  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({
    pendentes: [],
    estado: false,
    select2: null,
    select1: null,
    pesquisa_parameto: null,
    instituicao_dados: [],
    disabilita_ano: true,
    select_anolectivo: null,
    idMatricula: null,
    estudante: true,
    progresso: false,
    Pessoas: [],
    titulo: 'Dados do Usuario Principal',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],

    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Usuario Principal ', value: 'userMain' },
      { text: 'Email', value: 'emailUser' },
      { text: 'Telefone', value: 'telefoneUser' }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select

    this.carregarInstituicoesPendente()
  },
  methods: {

    async SelecionaUser () {
      // CarregaInscrição na turma
      try {
        this.instituicao_dados = await axios
          .get('/DadosInstituicaoPendente/' + this.select1)
          .then(res => res.data)
      } catch (error) {
        this.progresso = false
      }
    },

    async Carregar () {
      if (this.select1 != null) {
        this.pendentes = []
        this.instituicao_dados = []
        this.select1 = null
        this.carregarInstituicoesPendente()
      }
    },
    async AceitarInstituicao () {
      if (this.select1 != null) {
        try {
          this.estado = await axios
            .get('/ConcluirInstituicoesPendentes/' + this.select1)
            .then(res => res.data)
          this.Carregar()
        } catch (error) {
          this.progresso = false
        }
      }
    },
    async carregarInstituicoesPendente () {
      try {
        this.pendentes = await axios
          .get('/InstituicoesPendentes')
          .then(res => res.data)
        console.log('Ouu: ' + this.pendentes)
      } catch (error) {
        this.progresso = false
      }
    }

  }
}
</script>
